import Brand from "Components/brand/brand";
import React from "react";
import locale from "./page.locale";
import VersionInfo from "./versionInfo";
const panelStyle = {
    minWidth: "calc(100% / 3)",
    backgroundColor: "#fff",
    textAlign: "center",
    padding: "6em 4em"
};
export default function AboutPage() {
    return (React.createElement("div", { className: "flex-box-centered-content" },
        React.createElement("div", { className: "shadow border-rounded-medium m-auto", style: panelStyle },
            React.createElement(Brand, null),
            React.createElement("div", { className: "mt-1" },
                React.createElement("span", null, locale.VERSION),
                "\u00A0",
                React.createElement(VersionInfo, null)))));
}
